import { useTranslation } from "react-i18next";
import SEO from "./common/SEO";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUniversity } from "@fortawesome/free-solid-svg-icons";

const Conductor = ({ renderBody }) => {
  const { t, i18n } = useTranslation();
  const isEnglish = (i18n.language || "it").startsWith("en");
  const title = isEnglish ? "Conductor Massimo Belli" : "Direttore Massimo Belli";
  const desc = isEnglish
    ? "Biography and artistic career of Maestro Massimo Belli, conductor and musical director of the Nuova Orchestra da Camera Ferruccio Busoni."
    : "Biografia e carriera artistica del Maestro Massimo Belli, direttore musicale della Nuova Orchestra da Camera Ferruccio Busoni di Trieste.";

  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Massimo Belli",
    jobTitle: isEnglish ? "Conductor & Violinist" : "Direttore d'Orchestra e Violinista",
    worksFor: {
      "@type": "MusicGroup",
      name: "Nuova Orchestra da Camera Ferruccio Busoni",
    },
    image: "https://res.cloudinary.com/orchestrabusoni/image/upload/v1647612096/foto-di-F.Parenzan-8_halpwx.jpg",
  };

  return (
    <>
      <SEO
        title={title}
        description={desc}
        image="https://res.cloudinary.com/orchestrabusoni/image/upload/v1647612096/foto-di-F.Parenzan-8_halpwx.jpg"
        type="profile"
        schema={personSchema}
      />
      <section className="section subpage-section">
        <div className="container subpage-container">
          {/* Maestro Hero Card */}
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-5 maestro-hero-card">
            <div className="row g-0 align-items-center">
              <div className="col-lg-5 text-center p-4 p-md-5 bg-navy-maestro">
                <div className="maestro-img-wrapper d-inline-block">
                  <img
                    src="https://res.cloudinary.com/orchestrabusoni/image/upload/v1647612096/foto-di-F.Parenzan-8_halpwx.jpg"
                    alt="Maestro Massimo Belli"
                    className="img-fluid rounded-4 shadow-lg maestro-portrait"
                    loading="lazy"
                  />
                </div>
              </div>

              <div className="col-lg-7 p-4 p-md-5">
                <h2 className="subpage-title mb-2">Massimo Belli</h2>
                <h5 className="text-warning fw-semibold mb-4">
                  {isEnglish ? "Musical & Artistic Director" : "Direttore Musicale & Artistico"}
                </h5>
                <p className="lead-paragraph text-muted mb-0">
                  {t("conductor.par1")}
                </p>
              </div>
            </div>
          </div>

          {/* Artistic Biography Narrative */}
          <div className="conductor-bio-section bg-white p-4 p-md-5 rounded-4 shadow-sm border mb-5">
            <h3 className="section-subheading mb-4 pb-2 border-bottom">
              {isEnglish ? "Artistic Career & International Tours" : "Carriera Artistica & Tournée Internazionali"}
            </h3>
            <div className="subpage-text-content mb-4">
              {renderBody(t("conductor.par2"))}
            </div>

            <h3 className="section-subheading mt-5 mb-4 pb-2 border-bottom">
              {isEnglish ? "Guest Conducting & Masterclasses" : "Attività Direttoriale & Docenza Internazionale"}
            </h3>
            <div className="subpage-text-content">
              {renderBody(t("conductor.par3"))}
            </div>
          </div>

          {/* Institutional Roles & Appointments */}
          <div className="conductor-roles-section bg-light p-4 p-md-5 rounded-4 border">
            <div className="d-flex align-items-center mb-4">
              <FontAwesomeIcon icon={faUniversity} className="text-warning fs-3 me-3" />
              <div>
                <h3 className="section-subheading mb-0">
                  {isEnglish ? "Institutional Roles & Academic Appointments" : "Incarichi Istituzionali & Docenza"}
                </h3>
                <small className="text-muted">
                  {isEnglish ? "Tartini Conservatory & Opera Foundations" : "Conservatorio G. Tartini & Fondazioni Lirico-Sinfoniche"}
                </small>
              </div>
            </div>

            <div className="subpage-text-content role-list-styled">
              {renderBody(t("conductor.par4"))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Conductor;
